import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import apiAuth from "../../helpers/ApiAuth";
import { reMapApplianceRegister, reMapGetApplianceData } from "./normalizers";

import {
  REGISTER_APPLIANCE,
  REGISTER_APPLIANCE_SUCCESS,
  REGISTER_APPLIANCE_ERROR,
  EDIT_APPLIANCE,
  EDIT_APPLIANCE_SUCCESS,
  EDIT_APPLIANCE_ERROR,
  GET_APPLIANCE_DATA,
  GET_APPLIANCE_DATA_FAILURE,
  GET_APPLIANCE_DATA_SUCCESS,
  EDIT_CAMERA,
  EDIT_CAMERA_SUCCESS,
  EDIT_CAMERA_ERROR,
  APPLIANCE_ACTION_ERROR,
  LOGOUT_USER,
  UPDATE_CAMERA_TIME,
  UPDATE_CAMERA_TIME_SUCCESS,
  UPDATE_CAMERA_TIME_ERROR,
} from "../actions";

export function* watchActionError() {
  yield takeEvery(APPLIANCE_ACTION_ERROR, ActionError);
}

function* ActionError(message) {
  try {
    if (message.payload.response.status === 401) {
      yield put({ type: LOGOUT_USER });
    }

    yield put({
      type: message.payload.action,
      payload: message.payload.response,
    });
  } catch (error) {}
}

export function* watchRegisterAppliance() {
  yield takeEvery(REGISTER_APPLIANCE, registerAppliance);
}

const registerApplianceAsync = async ({ appliance_code, name, company }) =>
  await apiAuth
    .put(`/api/install/appliance/${appliance_code}/`, {
      company: company,
      name: name,
    })
    .then((appliances) => appliances.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* registerAppliance(applianceObj) {
  try {
    const appliances = yield call(registerApplianceAsync, applianceObj.payload);

    if (!appliances.message) {
      const mypayload = reMapApplianceRegister(appliances);

      yield put({ type: REGISTER_APPLIANCE_SUCCESS, payload: mypayload });
    } else {
      appliances.message.action = REGISTER_APPLIANCE_ERROR;
      yield put({ type: APPLIANCE_ACTION_ERROR, payload: appliances.message });
    }
  } catch (error) {
    yield put({ type: REGISTER_APPLIANCE_ERROR, payload: error });
  }
}

export function* watchGetApplianceData() {
  yield takeEvery(GET_APPLIANCE_DATA, getApplianceData);
}

const getApplianceDataAsync = async () =>
  await apiAuth
    .get("/api/appliance/web/")
    .then((appliances) => appliances.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* getApplianceData() {
  try {
    const appliances = yield call(getApplianceDataAsync);

    if (!appliances.message) {
      const mypayload = reMapGetApplianceData(appliances);

      yield put({ type: GET_APPLIANCE_DATA_SUCCESS, payload: mypayload });
    } else {
      appliances.message.action = GET_APPLIANCE_DATA_FAILURE;
      yield put({ type: APPLIANCE_ACTION_ERROR, payload: appliances.message });
    }
  } catch (error) {
    yield put({ type: GET_APPLIANCE_DATA_FAILURE, payload: error });
  }
}

export function* watchEditAppliance() {
  yield takeEvery(EDIT_APPLIANCE, editApplianceData);
}

const editApplianceAsync = async ({ appliance_id, name }) =>
  await apiAuth
    .patch(`/api/appliance/web/${appliance_id}/`, { name: name })
    .then((appliance) => appliance.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* editApplianceData(applianceObj) {
  try {
    const appliance = yield call(editApplianceAsync, applianceObj.payload);

    if (!appliance.message) {
      const { cameras, ...applianceData } = appliance;

      yield put({ type: EDIT_APPLIANCE_SUCCESS, payload: applianceData });
    } else {
      appliance.message.action = EDIT_APPLIANCE_ERROR;
      yield put({ type: APPLIANCE_ACTION_ERROR, payload: appliance.message });
    }
  } catch (error) {
    yield put({ type: EDIT_APPLIANCE_ERROR, payload: error });
  }
}

export function* watchEditCamera() {
  yield takeEvery(EDIT_CAMERA, editCameraData);
}

const editCameraAsync = async (camera) =>
  await apiAuth
    .patch(`/api/camera/${camera.camera_id}/`, camera)
    .then((appliance) => appliance.data)
    .catch((error) => {
      return {
        message: {
          response: error.response,
        },
      };
    });

function* editCameraData(cameraObj) {
  try {
    const { preview, ...cam_no_preview } = cameraObj.payload;
    const camera = yield call(editCameraAsync, cam_no_preview);

    if (!camera.message) {
      camera.appliance_id = cameraObj.payload.appliance_id;

      yield put({ type: EDIT_CAMERA_SUCCESS, payload: camera });
    } else {
      camera.message.action = EDIT_CAMERA_ERROR;
      yield put({ type: APPLIANCE_ACTION_ERROR, payload: camera.message });
    }
  } catch (error) {
    yield put({ type: EDIT_CAMERA_ERROR, payload: error });
  }
}

export function* watchUpdateCamera() {
  yield takeEvery(UPDATE_CAMERA_TIME, UpdateCamera);
}

function* UpdateCamera(cameraObj) {
  try {
    yield put({
      type: UPDATE_CAMERA_TIME_SUCCESS,
      payload: cameraObj.payload,
    });
  } catch (error) {
    yield put({ type: UPDATE_CAMERA_TIME_ERROR, payload: error });
  }
}

export default function* rootSaga() {
  yield all([fork(watchUpdateCamera)]);
  yield all([fork(watchActionError)]);
  yield all([fork(watchRegisterAppliance)]);
  yield all([fork(watchGetApplianceData)]);
  yield all([fork(watchEditAppliance)]);
  yield all([fork(watchEditCamera)]);
}
